export default "__VITE_ASSET__KV_E0twRcbPIhzxL8GygPA__";